import { MapPin, MonitorStop, Quote, Network } from 'lucide-react'
import { useFilter } from '@/hooks/use-filter'
import { FilterPanelProps } from './types'
import { DEFAULT_TITLE, DEFAULT_SUBTITLE } from './constants'
import { buildFiltersFromData, buildEmptyFilters } from './utils'
import {
  FilterPanelHeader,
  FilterSectionTagInput,
  FilterSectionFavorited,
  FilterSectionCreatedBy,
  FilterSectionSources,
  FilterPanelActions,
} from './components'

const PANEL_STYLE = { backgroundColor: '#FAFAFA' }

export function FilterPanel({
  isOpen,
  onClose,
  onApply,
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
}: FilterPanelProps) {
  const { data, set, clear } = useFilter()

  const handleApply = () => {
    onApply(buildFiltersFromData(data))
    onClose()
  }

  const handleClear = () => {
    clear()
    onApply(buildEmptyFilters())
    onClose()
  }

  const handleSourceToggle = (id: string, checked: boolean) => {
    if (checked) set('sourcesIds', [...data.sourcesIds, id])
    else set('sourcesIds', data.sourcesIds.filter((i) => i !== id))
  }

  if (!isOpen) return null

  return (
    <div
      className="w-80 flex flex-col h-[85dvh] overflow-hidden mr-5 rounded-[10px] border border-gray-200"
      style={PANEL_STYLE}
    >
      <FilterPanelHeader title={title} subtitle={subtitle} onClose={onClose} />
      <div className="flex-1 overflow-y-auto p-6">
        <div className="space-y-6">
          <FilterSectionTagInput
            icon={MapPin}
            label="Território"
            value={data.territoriesIds}
            onChange={(v) => set('territoriesIds', v)}
            items={data.territories}
            loading={data.isLoadingTerritories}
          />
          <FilterSectionFavorited
            value={data.favorited}
            onChange={(v) => set('favorited', v)}
          />
          <FilterSectionCreatedBy
            value={data.createdBy}
            onChange={(v) => set('createdBy', v)}
          />
          <FilterSectionTagInput
            icon={MonitorStop}
            label="Parceiros"
            value={data.partnersIds}
            onChange={(v) => set('partnersIds', v)}
            items={data.partners}
            loading={data.isLoadingPartners}
          />
          <FilterSectionSources
            sources={data.sources}
            selectedIds={data.sourcesIds}
            loading={data.isLoadingSources}
            onToggle={handleSourceToggle}
          />
          <FilterSectionTagInput
            icon={Quote}
            label="Tópico"
            value={data.topicsIds}
            onChange={(v) => set('topicsIds', v)}
            items={data.topics}
            loading={data.isLoadingTopics}
          />
          <FilterSectionTagInput
            icon={Network}
            label="Contexto"
            value={data.contextsIds}
            onChange={(v) => set('contextsIds', v)}
            items={data.contexts}
            loading={data.isLoadingContexts}
          />
          <FilterPanelActions onClear={handleClear} onApply={handleApply} />
        </div>
      </div>
    </div>
  )
}

export type { Filters } from './types'
